import React from 'react';
import EstruturaPagina from "../../EstruturaPagina"

export const FunnyJoke = () => {
    return (
        <div>
            <EstruturaPagina
                BackgroundImage={'/assets/joke/background.webp'}
                LogoImage={'/assets/joke/logo.webp'}
                TituloNome={'Funny Joke - One click one laugh'}
                LinkSite={'https://funny-joke-neon.vercel.app'}
                LinkGit={'https://github.com/PL-Developer-Code/Jokers'}
                TextoDescricao={'Projeto simples criado para arrancar risos :D'}
                ImgTec1={'/assets/html_img.webp'}
                NomeTec1={'HTML'}
                ImgTec2={'/assets/css_img.webp'}
                NomeTec2={'CSS'}
                ImgTec3={'/assets/js_img.webp'}
                NomeTec3={'JavaScript'}
                screenshots={[
                    { src: "/assets/joke/screenshot_01.png" },
                    { src: "/assets/joke/screenshot_02.png" }
                ]}
            />
        </div>
    )
}